module.exports = __webpack_public_path__ + "img/prize-03.0079f557.png";